import React from 'react'
import SignData from './SignData';
import { formatDateTimeWithAt } from './FormatDateTimeWithAt';
import { isSignedOrToBeCoSigned } from './utils';
import SignImagePreview from './SignImagePreview';

const SignatureEncounterPreview = ({data}) => {
    let signatureDateTimeFormatted = formatDateTimeWithAt(data?.Data?.ProviderSignatureDate)
    const EncounterCoSignData = data?.EncounterCoSign?.filter(enc => [ true, "true"].includes(enc.isCoSigned));
  return (
    <>
        <div className="d-flex flex-column gap-10">
            {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
                <div className="d-flex">
                    <div className="ar-sign-new-design d-flex flex-column gap-1">
                        <div className="">
                            <SignImagePreview BucketPath={data?.Data?.SignaturePath} />
                        </div>
                        <p className="heading text-black">Electronically Signed By/Date:</p>
                        <p className='heading green-text'>{data?.Data?.ProviderSignBy || 'N/A'} on {signatureDateTimeFormatted || 'N/A'}</p>
                    </div>
                </div>
                :
                null}
                {EncounterCoSignData?.map(it => 
                    <SignData data={it}/>
                )}
        </div>
    </>
  )
}

export default SignatureEncounterPreview